module.exports = {"pathContext":{"slug":"/en/Culture/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-culture.json
// module id = 1282
// module chunks = 185579923683717